<template>
<div class="CreateCohortDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="updateHideCreateGroupOverlayFlag($event,true)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Group Course
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="groupCourseMasterIdValue">
                        <option value='-1' disabled>Select</option>
                        <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj.GroupCourseMasterId">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Cohort Name
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="cohortObj.CohortName">
                        </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>

              <div v-if="showRecommendedActionUI">
                <hr width="94%" size="10px"/>
                <div class="row vertical-align margin-bottom-2Perc">
                  <div class="row col-md-1 col-lg-1"></div>
                  <div class="row col-md-3 col-lg-3 create-lesson-input-text-style text-align-left">
                    <b>Recommended Action Setup:</b>
                  </div>
                  <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">  
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12">
                      </div>
                    </div>
                  </div>
                  <div class="row col-md-3 col-lg-3"></div>
                </div>

                <div class="row margin-bottom-2Perc vertical-align" v-if="(cohortObj.RecommendActionsData.length > 0)">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    <div class="table-responsive margin-Top-3Perc" >
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-align-center font-size-15px border-right">SR. No.</th>
                            <th class="text-align-center font-size-15px border-right">Number of scheduled user meeting(s)</th>
                            <th class="text-align-center font-size-15px padding-left-0px padding-right-0px">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(currObj, index) in cohortObj.RecommendActionsData" :key="'recommended_action_' + index">
                            <td class="border-right text-align-center col-lg-3">{{(index + 1)}}</td>
                            <td class="border-right text-align-center col-lg-6">{{getCurrentCondition(currObj)}}</td>
                            <td class="text-align-center col-lg-3 cursor-pointer">
                              <a class="text-decoration-underline" @click="performUserClickAction($event, 'delete_current_recommended_action_rule', index)">Delete</a>
                            </td>         
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>

                <div class="row vertical-align margin-bottom-2Perc">
                  <div class="row col-md-1 col-lg-1"></div>
                  <div class="row col-md-3 col-lg-3 create-lesson-input-text-style-sub-label text-align-left">
                    <b>Create New</b>
                  </div>
                  <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">  
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12">
                      </div>
                    </div>
                  </div>
                  <div class="row col-md-3 col-lg-3"></div>
                </div>

                <div class="row vertical-align text-align-left">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-2 col-md-2 col-lg-2 font-size-12px">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0Perc Padding-right-0Px">
                        If
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3 padding-left-0Perc font-size-12px">
                    <div class="form-group">
                      <div class="col-sm-12 font-size-12px">
                        # of Scheduled Meeting
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-3 col-md-3 col-lg-3 padding-left-0Perc font-size-12px">
                      return # of Recommended Actions to user
                  </div>
                  <div class="col-md-1 col-lg-1 text-align-left"></div>
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                </div>

                <div class="row margin-bottom-2Perc vertical-align">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-2 col-md-2 col-lg-2">
                    <select class="form-control" v-model="conditionOperatorValue">
                      <option :value=constants.RecommendActionOperatorEnum.None disabled>Select</option>
                      <!-- <option :value=constants.RecommendActionOperatorEnum.LessThan>&#60; (Less Than)</option> -->
                      <option :value=constants.RecommendActionOperatorEnum.LessThanEqual>&le; (Less Than Or Equal To)</option>
                      <!-- <option :value=constants.RecommendActionOperatorEnum.GreaterThan>&gt; (Greater Than)</option> -->
                      <option :value=constants.RecommendActionOperatorEnum.GreaterThanEqual>&ge; (Greater Than Or Equal To)</option>
                      <!-- <option :value=constants.RecommendActionOperatorEnum.EqualTo>&#61; (Equal To)</option> -->
                    </select>
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3 padding-right-0Px">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0Perc Padding-right-0Px">
                        <input type="number" class="form-control" v-model="numberofMeetingsValue">
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 font-size-12px">
                    then
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3 padding-left-0Perc">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0Perc Padding-right-0Px">
                        <input type="number" class="form-control" v-model="returnActionCountValue">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1 col-lg-1 text-align-left">
                    <span class="glyphicon glyphicon-plus cursor-pointer font-size-18px text-color-green" @click="performUserClickAction($event, 'add_recommended_actions_rule', -1)"></span>            
                  </div>
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createCohort">+ Create New</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
 </div>
 </div>
</template>

<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import AlertBox from '@/components/AlertOverlay'
import { cohortService } from '@/server-util/cohort-service'
import Loader from '@/components/dashboard/Loader'
import { find, findIndex } from 'lodash'
export default {
  created: function () {
    this.setDefaultValues()
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      cohortObj: {
        GroupCourseMasterId: -1,
        CohortName: '',
        StartTS: '',
        EndTS: '',
        RecommendActionsData: []
      },
      recommendActionsDataObj: {
        NumberofMeetings: 0,
        ConditionOperator: -1,
        ReturnActionCount: 0
      },
      showSpinner: false,
      date1: new Date(),
      config: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: true,
        sideBySide: true,
        minDate: ''
      },
      showRecommendedActionUI: false,
      date2: new Date(),
      isCohortCreatedSuccessfully: false
    }
  },
  name: 'CreateCohortDiv',
  methods: {
    foundSameRule: function () {
      const foundIndex = findIndex(this.cohortObj.RecommendActionsData, (currObj) => {
        return (currObj.NumberofMeetings === this.numberofMeetingsValue && currObj.ConditionOperator === this.conditionOperatorValue && currObj.ReturnActionCount === this.returnActionCountValue)
      })
      return foundIndex > -1
    },
    validateRequiredFieldBeforeAddIntoRecommendedActionList: function () {
      if (this.numberofMeetingsValue === undefined && this.numberofMeetingsValue === null && this.numberofMeetingsValue === 'null' && this.numberofMeetingsValue === '') {
        this.showAlertDialog = true
        this.errorMsg = '# of Scheduled Meeting can\'t be empty.'
        return false
      } else if (this.conditionOperatorValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please specify condition for given rule.'
        return false
      } else if (this.returnActionCountValue === undefined && this.returnActionCountValue === null && this.returnActionCountValue === 'null' && this.returnActionCountValue === '') {
        this.showAlertDialog = true
        this.errorMsg = '# of Recommended Actions to return can\'t be empty.'
        return false
      } else if (this.cohortObj.RecommendActionsData.length > 0 && this.foundSameRule()) {
        this.showAlertDialog = true
        this.errorMsg = 'Given rule already exists in the list.'
        return false
      }
      return true
    },
    performUserClickAction: function (event, operationName, indexToDelete) {
      switch (operationName) {
        default:
          break
        case 'delete_current_recommended_action_rule':
          if (indexToDelete > -1) {
            this.cohortObj.RecommendActionsData.splice(indexToDelete, 1)
          }
          break
        case 'add_recommended_actions_rule':
          if (this.validateRequiredFieldBeforeAddIntoRecommendedActionList()) {
            var objToPush = {
              NumberofMeetings: this.numberofMeetingsValue,
              ConditionOperator: this.conditionOperatorValue,
              ReturnActionCount: this.returnActionCountValue
            }
            this.cohortObj.RecommendActionsData.push(objToPush)
            this.numberofMeetingsValue = 0
            this.conditionOperatorValue = -1
            this.returnActionCountValue = 0
          }
          break
      }
    },
    getCurrentCondition: function (currObj) {
      var valueToReturn = ''
      valueToReturn = ''
      switch (currObj.ConditionOperator) {
        case constants.RecommendActionOperatorEnum.None:
        default:
          valueToReturn += ' Not Found '
          break
        case constants.RecommendActionOperatorEnum.LessThan:
          valueToReturn += ' Less than '
          break
        case constants.RecommendActionOperatorEnum.LessThanEqual:
          valueToReturn += ' Less than or Equals to '
          break
        case constants.RecommendActionOperatorEnum.GreaterThan:
          valueToReturn += ' Greater than '
          break
        case constants.RecommendActionOperatorEnum.GreaterThanEqual:
          valueToReturn += ' Greater than or Equals to '
          break
        case constants.RecommendActionOperatorEnum.EqualTo:
          valueToReturn += ' Equals to '
          break
      }
      valueToReturn += currObj.NumberofMeetings + ' then return '
      valueToReturn += currObj.ReturnActionCount + ' action' + (currObj.ReturnActionCount > 1 ? 's' : '')
      return valueToReturn
    },
    setDefaultValues: function () {
      // AK: To not allow to select previous date
      this.config.minDate = new Date()
      this.date1 = new Date()
      this.date2 = new Date()
    },
    updateHideCreateGroupOverlayFlag: function (event, flagToUpdate) {
      this.$emit('updateFlag', flagToUpdate)
    },
    createCohort: function () {
      var storeObj = this.$store
      // var _this = this
      if (this.validateRequiredFieldBeforeSubmit()) {
        // AK: Assign values to object before create
        this.cohortObj.StartTS = this.date1
        this.cohortObj.EndTS = this.date2
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
        ) {
          // AK: Start showing Spinner
          this.$emit('showSpinner', true)
          this.cohortObj.RecommendActionsData = (this.showRecommendedActionUI && this.cohortObj.RecommendActionsData !== undefined && this.cohortObj.RecommendActionsData !== 'undefined' && this.cohortObj.RecommendActionsData !== null && this.cohortObj.RecommendActionsData !== 'null' && this.cohortObj.RecommendActionsData !== '' && this.cohortObj.RecommendActionsData.length !== 0) ? JSON.stringify(this.cohortObj.RecommendActionsData) : null
          cohortService
            .createCohort(
              storeObj.state.access_token,
              this.cohortObj
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Hide showing Spinner
                this.$emit('showSpinner', false)
                // AK: Store it
                storeObj.state.cohortList.push(responseObj.data)
                this.isCohortCreatedSuccessfully = true
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.cohortObj.CohortName + '\' cohort created successfully.'
              } else {
                // AK: Hide Spinner
                this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined CREATE NEW COHORT'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isCohortCreatedSuccessfully) {
        // AK: Hide Create Group Overlay
        this.$emit('updateFlag', true)
        this.isCohortCreatedSuccessfully = false
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    validateCohortName: function () {
      if (/^(\w+\s?)*\s*$/.test(this.cohortObj.CohortName)) {
        return true
      }
      return false
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.cohortObj.GroupCourseMasterId === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course.'
        return false
      } else if (this.cohortObj.CohortName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Name can\'t be empty.'
        return false
      } else if (this.cohortObj.CohortName.trim().match(/[!@#$%^&*()_+\-=[\]{};':"\\|,<>/?]/)) {
        this.showAlertDialog = true
        this.errorMsg = 'Special character(s) are not allowed in the name.'
        return false
      } else if (!this.validateCohortName()) {
        this.showAlertDialog = true
        this.errorMsg = 'More than one white space in between the name is not allowed.'
        return false
      }
      /*
      if (this.date1 === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter Start date.'
        return
      }
      if (this.date2 === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter End Date.'
        return
      }
      if (Date.parse(this.date1) > Date.parse(this.date2)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date must be less than the end date.'
        return
      }
      if (Date.parse(this.date1) === Date.parse(this.date2)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date and end date can\'t be same.'
        return
      }
      */
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker,
    'loader': Loader
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    recommendActionsDataObjValue: {
      get: function () {
        return this.recommendActionsDataObj
      },
      set: function (newValue) {
        this.recommendActionsDataObj = newValue
      }
    },
    numberofMeetingsValue: {
      get: function () {
        return this.recommendActionsDataObjValue.NumberofMeetings
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = '# of Scheduled Meeting value must be positive value.'
          } else {
            this.recommendActionsDataObjValue.NumberofMeetings = parseInt(newValue)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = '# of Scheduled Meeting value must be a non empty digit value.'
        }
      }
    },
    returnActionCountValue: {
      get: function () {
        return this.recommendActionsDataObjValue.ReturnActionCount
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = '# of Recommended Actions to return value must be positive value.'
          } else {
            this.recommendActionsDataObjValue.ReturnActionCount = parseInt(newValue)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = '# of Recommended Actions to return value must be a non empty digit value.'
        }
      }
    },
    conditionOperatorValue: {
      get: function () {
        return this.recommendActionsDataObjValue.ConditionOperator
      },
      set: function (newValue) {
        this.recommendActionsDataObjValue.ConditionOperator = parseInt(newValue)
      }
    },
    groupCourseMasterIdValue: {
      get: function () {
        return this.cohortObj.GroupCourseMasterId
      },
      set: function (newValue) {
        this.cohortObj.GroupCourseMasterId = newValue
        const foundObj = find(this.getGroupCourseList, (currentObj) => {
          return newValue === currentObj.GroupCourseMasterId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          this.showRecommendedActionUI = (foundObj.CourseMasterId === constants.Default_Meeting_Mentor_Course)
        } else {
          this.showRecommendedActionUI = false
          this.cohortObj.RecommendActionsData = []
          this.returnActionCountValue = 0
          this.conditionOperatorValue = -1
          this.numberofMeetingsValue = 0
        }
      }
    }
  }
}
</script>

<style scoped>
.Padding-right-0Px {
  padding-right: 0px;
}
.padding-left-0Perc {
  padding-left: 0px;
}
.font-size-12px {
  font-size: 12px;
}
.font-size-15px {
  font-size: 15px;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-color-green {
  color: green;
  background: white;
  border-radius: 50%;
  border: 1px solid gainsboro;
  padding: 5px;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.create-lesson-input-text-style-sub-label {
  color: #f39c12;
  font-size: 13px;
  text-decoration: underline;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.text-decoration-underline {
  text-decoration: underline;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/CreateCohortOverlay.vue